var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublishedBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 595.68 172.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#_\xF1_\xE8\xC3\xF1_\xEA_\xED\xCB\xC9O\xC9\xE2\xC9f\xC5_\xC9V\xC9\xE1\xC9\xEC_11);fill-rule:evenodd;filter:url(#drop-shadow-1);stroke-width:0px;}.cls-2{filter:url(#drop-shadow-2);}.cls-3{fill:#e1f0f1;stroke:#92d4d5;stroke-miterlimit:10;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_\\xF1_\\xE8\\xC3\\xF1_\\xEA_\\xED\\xCB\\xC9O\\xC9\\xE2\\xC9f\\xC5_\\xC9V\\xC9\\xE1\\xC9\\xEC_11",
    x1: 655.07,
    y1: 79.4,
    x2: 14.83,
    y2: 79.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#743d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#e6b84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#743d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#e6b84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#e0b147"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#d0a040"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#b68535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#925e26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#743d19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#7f491e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#9f6b2b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#d1a141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#e6b84a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#743d19"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#231f20",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 7,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#231f20",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M573.66,138.76l-40.65-65.18,40.65-63.04h-108.64S57.79,13.65,48.02,13.65s-17.36-6.47-26.04-5.44c-8.68,1.03-13.89,10.54-13.89,23.42v103.61c0,3.17-.07,10.5,1.07,15.46,2.1-8.46,6.45-13.27,12.82-14.45,6.37-1.18,18.26,5.44,27.25,5.44s415.79-3.11,415.79-3.11l108.64.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M172.18,80.47h-7.21v17.13h-11.63v-47.73h18.83c11.69,0,17.54,6.6,17.54,15.37,0,7.89-5.37,15.23-17.54,15.23ZM171.29,71.22c4.62,0,6.6-2.31,6.6-5.98s-1.97-5.98-6.6-5.98h-6.32v11.97h6.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M233.24,97.6h-11.63v-5.17c-2.31,3.26-6.39,5.58-11.49,5.58-8.77,0-14.69-6.05-14.69-16.18v-22.17h11.56v20.6c0,5.17,2.92,8.02,7.28,8.02s7.34-2.86,7.34-8.02v-20.6h11.63v37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M264.93,59.12c9.38,0,16.73,7.48,16.73,19.45s-7.41,19.58-16.73,19.58c-5.58,0-9.59-2.52-11.69-5.85v5.3h-11.63v-50.31h11.63v17.75c2.11-3.4,6.26-5.92,11.69-5.92ZM261.46,69.25c-4.35,0-8.3,3.33-8.3,9.38s3.94,9.38,8.3,9.38,8.36-3.4,8.36-9.45-3.94-9.31-8.36-9.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M287.78,47.29h11.63v50.31h-11.63v-50.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M306.75,49.47c0-3.54,2.79-6.32,6.94-6.32s6.87,2.79,6.87,6.32-2.79,6.26-6.87,6.26-6.94-2.79-6.94-6.26ZM307.84,59.66h11.63v37.94h-11.63v-37.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M343.33,98.15c-10.13,0-16.93-5.64-17.47-12.99h11.49c.27,2.65,2.65,4.42,5.85,4.42,2.99,0,4.56-1.36,4.56-3.06,0-6.12-20.67-1.7-20.67-15.64,0-6.46,5.51-11.76,15.43-11.76s15.23,5.44,15.98,12.92h-10.74c-.34-2.58-2.31-4.28-5.58-4.28-2.72,0-4.22,1.09-4.22,2.92,0,6.05,20.53,1.77,20.74,15.91,0,6.6-5.85,11.56-15.37,11.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M365.84,47.29h11.63v17.47c2.31-3.26,6.46-5.51,11.69-5.51,8.64,0,14.42,5.98,14.42,16.18v22.17h-11.56v-20.6c0-5.17-2.86-8.02-7.27-8.02s-7.28,2.86-7.28,8.02v20.6h-11.63v-50.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M428.54,98.15c-11.15,0-19.17-7.48-19.17-19.51s7.89-19.51,19.17-19.51,18.9,7.34,18.9,18.9c0,1.09-.07,2.24-.2,3.4h-26.31c.41,4.96,3.47,7.28,7.21,7.28,3.26,0,5.1-1.63,6.05-3.67h12.37c-1.83,7.41-8.57,13.12-18.02,13.12ZM420.99,74.96h14.55c0-4.15-3.26-6.53-7.14-6.53s-6.73,2.31-7.41,6.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M467.98,59.12c5.03,0,9.38,2.31,11.7,5.78v-17.61h11.63v50.31h-11.63v-5.44c-2.11,3.47-6.12,5.98-11.7,5.98-9.31,0-16.73-7.62-16.73-19.58s7.41-19.45,16.73-19.45ZM471.38,69.25c-4.35,0-8.29,3.26-8.29,9.31s3.94,9.45,8.29,9.45,8.3-3.33,8.3-9.38-3.88-9.38-8.3-9.38Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublishedBanner);
export default __webpack_public_path__ + "static/media/published-banner.d915d4a33fcd50415d33d49b58520eae.svg";
export { ForwardRef as ReactComponent };